// extracted by mini-css-extract-plugin
module.exports = {"serviceInfo__slider":"serviceInfo__slider-2ef5h"};